import { render, staticRenderFns } from "./ParagraphHeading.vue?vue&type=template&id=3c2530cb&scoped=true&"
import script from "./ParagraphHeading.vue?vue&type=script&lang=js&"
export * from "./ParagraphHeading.vue?vue&type=script&lang=js&"
import style0 from "./ParagraphHeading.vue?vue&type=style&index=0&id=3c2530cb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2530cb",
  null
  
)

export default component.exports